import React, { useMemo } from 'react'
import Table from 'antd/lib/table'

import apiManager from 'helpers/apiManager'
import useQuery from 'hooks/useQuery'
import { generatePath, Link } from 'react-router-dom'
import { ROUTES } from 'helpers/constants'
import { dateFormatter } from 'helpers'

const getSorter =
  ({ key, formatter = data => data }) =>
  (a, b) =>
    formatter(a[key]) - formatter(b[key])

const getStringSorter =
  ({ key }) =>
  (a, b) =>
    a[key].localeCompare(b[key])

const ProfileLink = ({ id, name }) => {
  const publicProfilePath = useMemo(() => generatePath(ROUTES.ADMIN_USER, { id }), [id])

  return (
    <Link to={publicProfilePath} target="_blank">
      {name}
    </Link>
  )
}

const columns = [
  {
    title: 'First User',
    dataIndex: 'firstUserName',
    key: 'firstUserId',
    sorter: getStringSorter({ key: 'firstUserName' }),
    render: (name, { firstUserId }) => <ProfileLink id={firstUserId} name={name} />,
  },
  {
    title: 'Second User',
    dataIndex: 'secondUserName',
    key: 'secondUserId',
    render: (name, { secondUserId }) => <ProfileLink id={secondUserId} name={name} />,
  },
  {
    title: 'Source',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: 'Preferred Date',
    dataIndex: 'preferredDate',
    key: 'preferredDate',
  },
  {
    title: 'Match Time',
    dataIndex: 'timestamp',
    key: 'timestamp',
    render: text => (text ? dateFormatter.returnYYYYMMDD(text) : ''),
    sorter: getSorter({ key: 'timestamp', formatter: data => new Date(data) }),
  },
]

const AdminMatches = () => {
  const { data } = useQuery('admin/matches', () => apiManager.adminGetMatches())
  const matches = useMemo(
    () =>
      data?.map(match => ({
        ...match,
        key: match.id,
      })) || [],
    [data]
  )

  return (
    <div className="w-full min-h-screen px-4 bg-white py-4 md:px-10">
      <h1 className="text-4xl text-center mb-5">Matches</h1>
      <div>
        <Table
          columns={columns}
          dataSource={matches}
          pagination={{
            defaultPageSize: 10,
          }}
        />
      </div>
    </div>
  )
}

export default AdminMatches
